<!-- Duplicate appointment -->
<p-drawer
  [visible]="duplicateAppointment()"
  [showCloseIcon]="false"
  position="right"
  [blockScroll]="true"
  styleClass="w-full md:w-30rem client-profile-sidebar p-0"
  (onHide)="HideDuplicatePopup(false)"
  [dismissible]="!disableSaveBtn"
  data-testid="duplicate-appointment-sidebar"
>
  <ng-template #header>
    <!-- Header -->
    <div class="border-bottom-1 border-300 sticky top-0 left-0 z-3">
      <!-- Header Top -->
      <div class="flex border-bottom-1 border-300 surface-0">
        <!-- Close Icon -->
        <div
          class="w-2rem px-4 cursor-pointer surface-200 flex align-items-center justify-content-center"
          (click)="HideDuplicatePopup(false)"
          data-testid="close-duplicate-sidebar"
        >
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <!-- Close Icon -->

        <strong
          class="text-green-400 font-bold text-sm m-2 p-1"
          aria-label="appointment-type"
          >{{
            appointment()!.type_name_primary_language ||
              appointment()!.type_name_secondary_language
          }}</strong
        >
      </div>
      <!-- Header Top -->

      <!-- Header Bottom -->
      <div
        class="bg-green-50 md:flex align-items-start md:align-items-center justify-content-between py-2 md:py-3 relative px-2 xl:px-0"
      >
        <!-- Client Name -->
        @if (appointment()) {
          <div class="md:w-6 px-2" aria-label="client-info">
            <div class="flex align-items-center">
              @if (appointment()!.clients[0].image) {
                <p-avatar
                  [image]="appointment()!.clients[0].image"
                  aria-label="client-avatar"
                />
              } @else {
                <p-avatar
                  [label]="
                    appointment()!.clients[0].full_name | titlecase | shortName
                  "
                  aria-label="client-avatar-placeholder"
                />
              }
              <div
                class="ml-2 w-full md:w-auto flex align-items-center justify-content-between md:block"
              >
                <div class="mr-2 text-sm flex align-items-center">
                  <strong
                    class="cursor-pointer text-primary overflow-hidden white-space-nowrap text-overflow-ellipsis"
                    tooltipPosition="left"
                    pTooltip="Anjana Mishra"
                    tooltipStyleClass="text-xs"
                    aria-label="client-name"
                    >{{ appointment()!.clients[0].full_name }}</strong
                  >
                  <span
                    class="text-xs text-600 ml-2 font-normal"
                    aria-label="client-id"
                  >
                    - {{ appointment()!.clients[0].client_id }}</span
                  >
                </div>
                <div class="flex align-items-center ml-2 md:ml-0">
                  <div
                    [innerHTML]="clientStatus(appointment()!.clients[0])"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Client Name -->

        <!-- Payment Status -->
        @if (appointment()!.clients[0].medical_alert) {
          <div
            (click)="GetClietMedicalDetails(appointment()!.clients[0])"
            class="mx-3 flex align-items-center cursor-pointer text-primary text-xs"
            data-testid="medical-alert-button"
          >
            <img
              src="/assets/img/icons/icon-medical-alert.svg"
              alt="Medical alert"
            />
            <span class="ml-2">{{
              'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate
            }}</span>
          </div>
        }
        <!-- Payment Status -->
      </div>
      <!-- Header Bottom -->
    </div>
  </ng-template>
  <!-- Header -->

  <!-- Content Wrapper -->
  <ng-template #content>
    <form
      class="p-sidebar-content__wrapper flex flex-column justify-content-between"
      [formGroup]="duplicateAppointmentForm"
      (ngSubmit)="CreateDuplicateAppointment(duplicateAppointmentForm)"
      aria-label="duplicate-appointment-form"
    >
      <div class="p-3">
        <!-- Form Group -->
        <div class="mb-2">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="datetime-label"
            >{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label
          >
          <p-datepicker
            inputId="calendar-12h"
            formControlName="startDate"
            [showTime]="true"
            styleClass="text-sm w-full"
            inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
            [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
            [minDate]="minimumDate"
            hourFormat="12"
            aria-label="datetime-calendar"
          />
          @if (StartDateFormControl.touched && StartDateFormControl.invalid) {
            <app-error-msg
              [errors]="StartDateFormControl.errors"
              [fieldLabel]="
                'SCHEDULE.CREATEAPPOINTMENT.LBL_STARTDATE' | translate
              "
            />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="w-full mb-3">
          <!-- Input Field -->
          @if (
            appointment() && appointment()!.is_recurring && !RRuleObject.RRule
          ) {
            <div
              class="p-input-icon-right w-full text-sm"
              (click)="showRRule = true"
              data-testid="repeat-input"
            >
              <div
                class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full"
              >
                {{ 'SCHEDULE.VIEWCLASS.REPEAT' | translate }}
              </div>
            </div>
          }
          @if (
            appointment() && appointment()!.is_recurring && RRuleObject.RRule
          ) {
            <div
              class="p-input-icon-right w-full text-sm cursor-pointer"
              data-testid="repeat-selected"
            >
              <i
                class="fa fa-times text-xl text-600"
                (click)="
                  showRRule = false;
                  RRuleObject.RRule = '';
                  RRuleObject.RRuleText = ''
                "
                data-testid="clear-repeat"
              ></i>
              <div
                class="p-inputtext p-component p-element w-full"
                (click)="showRRule = true"
              >
                {{ RRuleObject.RRuleText }}
              </div>
            </div>
          }
          <!-- Input Field -->
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-2">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="select-trainer-label"
            >{{ 'SCHEDULE.CREATECLASS.SELECTTRAINER' | translate }}</label
          >
          <staff-selector
            [formGroup]="duplicateAppointmentForm"
            [controlName]="SelectedTrainerFormControl"
            [id]="selectedTrainerId"
            [styleClass]="'w-full text-sm'"
            [placeHolder]="'common.PLACEHOLDER.SEARCH_AND_SELECT' | translate"
            [filterstaff]="filterStaffIds"
            aria-label="trainer-selector"
          />
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="virtual-url-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_VIRTUALURL' | translate }}</label
            >
            <input
              type="url"
              class="text-sm w-full"
              pInputText
              formControlName="virtualUrl"
              #keyUpInputDelay
              placeholder="{{ 'SCHEDULE.VIEWCLASS.VIRTUALURL' | translate }}"
              (keyup)="onKeyUpDelay()"
              aria-label="virtual-url-input"
            />
            @if (
              VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
            ) {
              <app-error-msg
                [errors]="VirtualUrlFormControl.errors"
                [fieldLabel]="
                  'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                "
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        @if (!isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="select-room-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_ROOM' | translate }}</label
            >
            <select-room
              [formGroup]="duplicateAppointmentForm"
              [controlName]="SelectedRoomFormControl"
              [tenantId]="tenantId()"
              [roomId]="selectedRoomId"
              (selectedRoom)="getSelectedRoomEvent($event)"
              aria-label="room-selector"
            />
            @if (
              SelectedRoomFormControl.touched && SelectedRoomFormControl.invalid
            ) {
              <app-error-msg
                [errors]="SelectedRoomFormControl.errors"
                [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_ROOM' | translate"
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="comments-label"
            >{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}</label
          >
          <textarea
            pInputTextarea
            class="w-full text-sm h-4rem"
            formControlName="comments"
            placeholder="{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}"
            aria-label="comments-textarea"
          >
          </textarea>
        </div>
        <!-- Form Group -->

        <hr
          class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
        />

        @if (appointment()) {
          <div class="grid text-sm">
            <div class="col-12 md:col-6">
              <label
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="subpurpose-label"
                >{{
                  'SCHEDULE.CREATEAPPOINTMENT.SELECT_SUB_PURPOSE' | translate
                }}</label
              >
              <p-select
                [options]="appointmentSubTypeList$ | async"
                optionLabel="name_primary_language"
                filterBy="name_primary_language"
                styleClass="md:w-full align-items-center text-sm border-none p-0 -mt-2"
                formControlName="selectedApptSubType"
                placeholder="{{
                  'SCHEDULE.CREATEAPPOINTMENT.SELECTWITHDOTS' | translate
                }}"
                aria-label="subpurpose-dropdown"
              >
                <ng-template pTemplate="selectedItem">
                  @if (selectedApptSubType) {
                    <div class="text-sm font-bold">
                      {{ selectedApptSubType.name_primary_language }}
                    </div>
                  }
                </ng-template>
                <ng-template let-subpurpose pTemplate="item">
                  <div class="text-sm ml-2">
                    {{ subpurpose.name_primary_language }}
                  </div>
                </ng-template>
              </p-select>
            </div>
            <div class="col-12 md:col-6">
              <label
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="appointment-type-label"
                >{{ 'SCHEDULE.CREATEAPPOINTMENT.APPT_TYPE' | translate }}</label
              >
              <p-select
                [options]="appointmentTypes"
                formControlName="selectedBehaviourType"
                optionLabel="name"
                filterBy="name"
                styleClass="md:w-full align-items-center text-sm border-none p-0 -mt-2"
                (onChange)="selectAction($event)"
                aria-label="appointment-type-dropdown"
              >
                <ng-template pTemplate="selectedItem">
                  @if (GetSelectedBehaviour) {
                    <div class="text-sm font-bold">
                      <i
                        class="{{ GetSelectedBehaviour.icon }} mr-3"
                        aria-label="appointment-type-icon"
                      ></i>
                      {{
                        'SCHEDULE.CREATEAPPOINTMENT.' +
                          GetSelectedBehaviour.name | translate
                      }}
                    </div>
                  }
                </ng-template>
                <ng-template let-types pTemplate="item">
                  <div class="text-sm font-bold">
                    <i
                      class="{{ types.icon }} mr-3"
                      aria-label="appointment-type-icon"
                    ></i>
                    {{ 'SCHEDULE.CREATEAPPOINTMENT.' + types.name | translate }}
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        }

        <!-- <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-3">
          <div class="flex align-items-center">
            <p-toggleSwitch formControlName="accepts_trial"></p-toggleSwitch>
            <p class="text-sm mb-0 ml-3 -mt-1">{{'SCHEDULE.VIEWAPPOINTMENT.APPOINTMENT_TRIAL' | translate}}</p>
          </div> -->
      </div>
      <!-- Content Wrapper -->

      <!-- Footer -->
      <div
        class="sticky bottom-0 left-0 mt-3 z-3 flex align-items-center justify-content-between border-top-1 border-300 p-3 surface-0"
      >
        <div class="w-4">
          <p-button
            type="button"
            [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
            class="p-button-secondary p-button-text text-sm"
            (click)="HideDuplicatePopup(false)"
            styleClass="p-button-link text-sm"
            aria-label="cancel-duplicate-button"
          />
        </div>
        <div class="w-8 text-right">
          <button
            pButton
            pRipple
            type="submit"
            [label]="'SCHEDULE.VIEWAPPOINTMENT.SAVE_DUP_APPT' | translate"
            class="text-sm"
            [disabled]="disableSaveBtn"
            [loading]="disableSaveBtn"
            aria-label="save-duplicate-button"
          ></button>
        </div>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>
</p-drawer>
<!-- Duplicate appointment -->

<app-rrule
  [visible]="showRRule"
  [showNeverStop]="true"
  [minimumDate]="minimumDate"
  [rRuleObj]="RRuleObject"
  (hideRrule)="HideRRule($event)"
  (emitRRule)="FetchRRuleData($event)"
  aria-label="recurrence-rule-dialog"
/>

@if (showErrorPopup$ | async; as showPopup) {
  <app-errors
    [error]="error"
    [visible]="showPopup"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-dialog"
  />
}
